export default {
  listHeaders() {
    return [
      { text: '', value: '' },
      { text: 'Ad', value: 'name' },
      { text: 'Soyad', value: 'surname' },
      { text: 'Email', value: 'email' },
      { text: 'Sil', value: 'Buttons' },
      { text: 'Şifre Reset', value: 'Buttons' },
    ];
  },
};
